import React from 'react';
import {Button, Icon, designSystemToken} from '@lightricks/react-design-system';
import {styled} from '@mui/material';
import clsx from 'clsx';
import translate from '@/utils/translate';
import styles from './ContactUsButton.module.scss';
import {SUPPORT_EMAIL} from '@/config/constants';
import {navigateWithAnalytics} from '@/utils/wrappers/Delta';
import useGenericButtonPressedEvent from '@/hooks/analytics/use-generic-button-pressed-event/useGenericButtonPressedEvent';

type ContactUsButtonProps = {
  className?: string;
  screen_name: string;
  buttonText?: string;
  textColor?: 'primary' | 'secondary';
};

const StyledButton = styled(Button, {
  shouldForwardProp: (prop: string) => prop !== 'textColor',
})<{textColor?: 'primary' | 'secondary'}>(({textColor}) => ({
  width: 'auto',
  minWidth: 'auto',
  padding: 0,
  margin: 0,
  height: 'auto',
  gap: '8px',
  ...(textColor === 'secondary' && {
    'color': designSystemToken('semantic.fg.secondary'),
    '& svg': {
      color: designSystemToken('semantic.fg.secondary'),
      fill: designSystemToken('semantic.fg.secondary'),
    },
    '& span': {
      color: designSystemToken('semantic.fg.secondary'),
    },
  }),
}));

function ContactUsButton({
  className,
  screen_name,
  buttonText,
  textColor = 'primary',
}: ContactUsButtonProps) {
  const {pressed} = useGenericButtonPressedEvent();
  const handleContactUs = async () => {
    pressed({
      button_name: 'Reonboarding Contact Us Button',
      screen_name,
    });
    const mailtoLink = `mailto:${SUPPORT_EMAIL}`;
    await navigateWithAnalytics(mailtoLink);
  };

  const iconAppearance = textColor === 'secondary' ? 'secondary' : 'primary';

  return (
    <StyledButton
      className={clsx(buttonText && styles.contactUsButtonWithText, className)}
      onClick={handleContactUs}
      appearance="overlay"
      size="medium"
      mode="plain"
      title={translate('Contact us')}
      textColor={textColor}
      icon={
        <Icon
          name="Navigation-Mail"
          size="medium"
          appearance={iconAppearance}
        />
      }
    >
      {buttonText}
    </StyledButton>
  );
}

export default ContactUsButton;
